<template>
	<v-layout fill-height wrap>
		<v-flex md12>
			<FormsList :forms="formsList" :is-loading="isListing" @createForm="openCreateBuilder" @editForm="openEditBuilder" />
		</v-flex>

		<embedded-forms-app-dialog
			v-if="embeddedBuilder.dialog"
			:dialog="embeddedBuilder.dialog"
			:title="embeddedBuilder.title"
			:path="embeddedBuilder.path"
			@close="closeBuilder"
			@ready="onBuilderReady"
			@routeChanged="onBuilderRouteChanged"
			@authLoginStarted="onBuilderAuthStarted"
			@builderSaved="onBuilderSaved"
			@builderPublished="onBuilderPublished"
			@builderCloseRequested="closeBuilder"
		/>
	</v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FormsList from '@/components/forms/FormsList.vue';
import EmbeddedFormsAppDialog from '@/components/forms/EmbeddedFormsAppDialog.vue';
import toast from '@/services/toasts/index.js';

export default {
	name: 'PageForms',
	components: {
		FormsList,
		EmbeddedFormsAppDialog
	},
	data() {
		return {
			embeddedBuilder: {
				dialog: false,
				title: 'Create Form',
				path: ''
			}
		};
	},
	computed: {
		...mapGetters({
			loggedInTenant: 'loggedInTenant',
			formsList: 'forms/formsList',
			isListing: 'forms/isListing'
		})
	},
	methods: {
		...mapActions({
			listForms: 'forms/list'
		}),
		openCreateBuilder() {
			if (!this.loggedInTenant || !this.loggedInTenant.id) return;

			this.embeddedBuilder = {
				dialog: true,
				title: 'Create Form',
				path: `/internal/forms/${this.loggedInTenant.id}/builder/new`
			};
		},
		openEditBuilder(form) {
			if (!this.loggedInTenant || !this.loggedInTenant.id || !form || !form.id) return;

			this.embeddedBuilder = {
				dialog: true,
				title: `Edit ${form.name || 'Form'}`,
				path: `/internal/forms/${this.loggedInTenant.id}/builder/${form.id}`
			};
		},
		closeBuilder() {
			this.embeddedBuilder.dialog = false;
		},
		onBuilderReady() {
			this.$store.dispatch('setPageTitle', 'Forms');
		},
		onBuilderRouteChanged() {
			this.$store.dispatch('setPageTitle', 'Forms');
		},
		onBuilderAuthStarted() {
			// Embedded builder shows its own auth overlay.
		},
		async onBuilderSaved(payload) {
			await this.listForms();
			toast.success(payload && payload.name ? `${payload.name} saved` : 'Form saved');
		},
		async onBuilderPublished(payload) {
			await this.listForms();
			toast.success(payload && payload.name ? `${payload.name} published` : 'Form published');
			this.closeBuilder();
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', 'Forms');
		this.listForms();
	}
};
</script>

<style scoped></style>
